import { createSlice } from '@reduxjs/toolkit';

export const onModalAddress = createSlice({
  name: 'onModalAddress',
  initialState: {
    data: false,
  },

  reducers: {
    setOnModalAddress: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setOnModalAddress } = onModalAddress.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getOnModalAddress = (state) => {
  return state.onModalAddress.data;
};

export default onModalAddress.reducer;
